<template>
  <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="348px"
    top="30vh"
  >
    <div class="confirm-container">
      <div class="confirm-tip">
        {{ language.softInstall.goApply }}
      </div>
      <div class="info-container">
        <div class="info-content">
          <div class="info-title">{{ language.permission.auth }}:</div>
          {{ language.permission.admin }}
        </div>
        <div class="info-content">
          <div class="info-title">{{ language.permission.applyDst }}:</div>
          {{ device }}
        </div>
        <div class="info-content">
          <div class="info-title">{{language.permission.applyUser}}:</div>{{currentUser}}
        </div>
        <div class="info-content">
          <div class="info-title">{{ language.permission.approver }}:</div>
          {{ approver }}
        </div>
        <div class="info-content">
          <div class="info-title">{{ language.permission.status }}:</div>
          <div :style="showColor">{{ status }}</div>
        </div>
      </div>
      <div class="reason-container">
        <el-input
          size="small"
          v-if="enableApply"
          type="textarea"
          :rows="2"
          :placeholder="language.softInstall.applyReason"
          clearable
          v-model="applyReason"
        ></el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="button-cancel" @click="Hide">{{ language.return }}</el-button>
      <el-button
        class="button-confirm"
        v-if="enableApply"
        type="primary"
        :disabled="!enableApply"
        :loading="submitting"
        @click="Submit"
        >{{ language.permission.goApply }}</el-button
      >
      <el-button class="button-confirm" v-if="enableAddAdmin" type="primary" @click="AddAdmin">{{
        language.permission.addAdmin
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      enableApply: false,
      enableAddAdmin: false,
      applyReason: '',
      submitting: false,
      status: '',
      approver: '',
      showColor: 'color:#909399',
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.checkApplyResult();
      } else {
        this.enableApply = false;
        this.enableAddAdmin = false;
        this.applyReason = '';
        this.status = '';
        this.approver = '';
        this.submitting = false;
        this.statusType = -1;
      }
    },
  },
  inject: ['gridTemplate'],
  props: {
    language: Object,
    show: Boolean,
    device: String,
    userinfo: Object,
    currentUser: String,
  },
  methods: {
    ...mapActions([
      'applyPcAdmin',
      'getPcAdminApply',
      'getCheckInfo',
      'getUserLeaderFive',
      'saveLog',
    ]),
    getStatus(status) {
      switch (status) {
        case 0:
          return this.language.permission.applying;
        case 1:
          return this.language.permission.approved;
        case -1:
          return this.language.permission.canceled;
        case -2:
          return this.language.permission.refused;
        default:
          return this.language.permission.apply;
      }
    },
    getColor(status) {
      switch (status) {
        case 0:
          return 'color:#409EFF';
        case 1:
          return 'color:#67C23A';
        case -1:
          return 'color:#F56C6C';
        case -2:
          return 'color:#F56C6C';
        default:
          return 'color:#909399';
      }
    },
    Hide() {
      this.gridTemplate.hideAdminApplyDialog();
    },
    async Submit() {
      if (this.applyReason.trim() === '') {
        this.$message.warning(this.language.softInstall.applyReason);
        return;
      }
      this.submitting = true;
      await this.applyPcAdmin({
        empCode: this.userinfo.empcode,
        pcName: this.device,
        reason: this.applyReason,
        displayName: this.userinfo.displayName,
      });
      this.saveLog({
        title: 'Apply Administrator',
        target: 'applyPcAdmin',
        description: `Reason: ${this.applyReason}`,
        reserve1: 'AdminApplyDialog >  applyPcAdmin',
      });
      this.submitting = false;
      this.applyReason = '';
      await this.checkApplyResult();
    },
    async AddAdmin() {
      const account = this.userinfo.username;
      const result = await this.getCheckInfo(`add_admin/${account}/${this.device}`);
      if (!result || result.status === 'failed') {
        this.saveLog({
          title: 'api_error',
          target: 'getCheckInfo',
          description: 'get CheckInfo failed',
          reserve1: 'AdminApplyDialog >  AddAdmin',
        });
        return;
      }
      const applyCommand = {
        userName: account,
        checkCode: result.data.checkCode,
        type: 'add_admin',
      };
      this.gridTemplate.applyCommand = applyCommand;
      this.gridTemplate.submitApply();
      this.Hide();
    },
    async checkApplyResult() {
      const getApplyRes = await this.getPcAdminApply({
        empcode: this.userinfo.empcode,
        pcName: this.device,
      });
      const getLeaderGap = await this.getUserLeaderFive(this.userinfo.empcode);
      if (getLeaderGap && getLeaderGap.code === 1) {
        const { displayName } = getLeaderGap.data;
        this.approver = displayName;
      }
      if (getApplyRes && getApplyRes.code === 1) {
        const applyList = getApplyRes.data;
        if (applyList.length > 0) {
          const { status } = applyList[0];
          this.status = this.getStatus(status);
          this.showColor = this.getColor(status);
          this.enableApply = status < 0;
          this.enableAddAdmin = status === 1;
        } else {
          this.enableApply = true;
          this.status = this.getStatus('');
        }
      }
    },
    GoService() {
      this.saveLog({
        title: 'Apply Administrator',
        target: 'GoService',
        description: 'Apply Administrator by Customer Service(Approver Level is To High)',
        reserve1: 'AdminApplyDialog >  GoService',
      });
      window.location = this.language.service;
      this.Hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.info-container {
  margin: 0 20px 10px 20px;
  color: #1466de;
  .info-content {
    display: flex;
    line-height: 25px;
    .info-title {
      color: #333;
      width: 80px;
      text-align: right;
      padding-right: 5px;
    }
  }
}
.reason-container {
  margin: 0 20px;
}
.confirm-tip {
  margin-left: 20px;
}
.confirm-content {
  white-space: pre-wrap;
}
.high-gap {
  font-size: 12px;
  color: #f56c6c;
  margin: 10px 20px;
  text-align: center;
  white-space: pre-wrap;
}
</style>
